import { render, staticRenderFns } from "./AdminMessageAddMultiple.vue?vue&type=template&id=74705502&"
import script from "./AdminMessageAddMultiple.vue?vue&type=script&lang=js&"
export * from "./AdminMessageAddMultiple.vue?vue&type=script&lang=js&"
import style0 from "./AdminMessageAddMultiple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports